import email from "../assets/email.png";
import api from "../assets/api.png";
import cpp from "../assets/cpp.png";
import css from "../assets/css.png";
import git from "../assets/git.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";
import vue from "../assets/vue.png";
import linkedin from "../assets/linkedin.png";
import gmail from "../assets/gmail.png";

import profile from "../assets/programmer.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  email,
  api,
  cpp,
  css,
  git,
  html,
  javascript,
  node,
  python,
  react,
  sass,
  typescript,
  vue,
  profile,
  circle,
  logo,
  linkedin,
  gmail,
};
